import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType, computed } from 'vue'
import { useRouter } from 'vue-router'
import WaterPanelUI from '@/components/top/panels/WaterPanel/WaterPanelUI.vue'
import { DefinitionInfoTopGraphicalMapPanelWater } from '@/models/initData/DefinitionInfo'
import { usePresentStore } from '@/stores/presentStore'
import { useInitDataStore } from '@/stores/initDataStore'
import { renderValue } from '@/lib/formatter'


export default /*#__PURE__*/_defineComponent({
  props: {
  cell: {
    type: Object as PropType<DefinitionInfoTopGraphicalMapPanelWater>,
    required: true,
  },
},
  setup(__props) {

const props = __props

const router = useRouter()
const presentStore = usePresentStore()
const initDataStore = useInitDataStore()

const getStationName = (stationId: string) => {
  const station = initDataStore.initData.stations.findById(stationId)

  return station?.name || ''
}

const cell = computed(() => props.cell)

const cellToParams = (cell: DefinitionInfoTopGraphicalMapPanelWater) => {
  const { no, stationId } = cell.args
  const stationName = getStationName(stationId)
  const updatedAt = presentStore.getTime(stationId, 'HH:mm')
  const waterLevel = presentStore.getValue(stationId, 'waterLevel') || 0
  const leveeCrown = renderValue(waterLevel, 2)
  const diff = presentStore.getDiff(stationId, 'waterLevel') || 0
  const ap = renderValue(cell.args.ap + waterLevel, 2)

  return {
    no,
    stationName,
    updatedAt,
    leveeCrown,
    ap,
    diff,
  }
}

const params = computed(() => cellToParams(cell.value))

const onClick = () => {
  const stationId = cell.value.args.stationId
  const path = `/water_detail/${stationId}`

  router.push(path)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WaterPanelUI, _mergeProps({ onClick: onClick }, _unref(params)), null, 16))
}
}

})